import React from 'react';

const AddressMapContainer = () => {
    const address = "47 Av. du docteur Arnold Netter, 75012 Paris, France";

    return (
        <div className="container">
            <div className="w-full mx-auto pb-16">
                <div className="relative w-full rounded-lg overflow-hidden" style={{height: "50vh"}}>
                    <iframe
                        title="Google Map"
                        className="w-full h-full"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2625.7490214225577!2d2.4052357!3d48.8439258!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e673aa24f64411%3A0x844679f2dc5b4c3e!2sMesProcedures.fr!5e0!3m2!1sen!2stn!4v1747720288956!5m2!1sen!2stn"
                        allowFullScreen=""
                        referrerPolicy="no-referrer-when-downgrade"
                        style={{border: 0}}
                    ></iframe>

                </div>

            </div>
        </div>);
};

export default AddressMapContainer;